import { mapGetters } from 'vuex';

export default {
  props: {
    storeModulePath: {
      type: String,
      default: '',
    },
    storeSubmoduleName: {
      type: String,
      default: '',
    },
    text: {
      type: String,
    },
    description: {
      type: String,
    },
    labelParentel: {
      type: String,
    },
    labelPrev: {
      type: String,
    },
    labelNext: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(['content']),
    storeModuleName() {
      return this.storeModulePath.substring(0, this.storeModulePath.length - 1);
    },
    useStoreModule() {
      return this.storeModulePath && this.storeModulePath !== '';
    },
    useStoreSubmodule() {
      return this.storeSubmoduleName && this.storeSubmoduleName !== '';
    },
    storeModuleUsed() {
      // get correct reference (either root hierarchy or leveled submodule hierarchy)
      let module = this.$store.state[this.storeModuleName];

      if (this.useStoreSubmodule) {
        module = this.$store.state[this.storeModuleName][this.storeSubmoduleName];
      }

      return module;
    },
    labelPrevOutput() {
      return (this.labelPrev && this.labelPrev !== '') ? this.labelPrev : this.content.back_cta;
    },
    labelNextOutput() {
      return (this.labelNext && this.labelNext !== '') ? this.labelNext : this.content.next_cta;
    },
  },
};
